import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_41.module.css";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter41.json";
import Common_html from "./Common_html";

export default function Chapter_41() {

    //   const corosalref = useRef()

    //   useEffect(()=>{
    //     if(corosalref.current)
    //     {
    //         corosalref.current.scrollIntoView({
    //             behavior: "smooth",
    //             block: "nearest",
    //             inline: "start"
    //         })
    //     }
    //     console.log("CurrentImageComponent",corosalref.current);
    // },[corosalref.current])
    return (
        <>
            <Head>
                <title>PERSONAL DAIMŌN AND HOLY GUARDIAN ANGEL | School of Our Divine Infinite Being</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                ></meta>
                <meta
                    name="keywords"
                    content="Divine Infinite Being, Central Doctrine, Chapter-XLII"
                ></meta>
                <meta
                    property="og:title"
                    content="PERSONAL DAIMŌN AND HOLY GUARDIAN ANGEL | School of Our Divine Infinite Being"
                ></meta>
                <meta property="og:type" content="website"></meta>
                <meta
                    property="og:image"
                    content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
                ></meta>
                <meta property="og:image:alt" content="Illustration depicting the connection between an individual and their Personal Daimōn and Holy Guardian Angel, symbolizing spiritual guidance and the path to Divine enlightenment within the Divine Infinite Being doctrine."></meta>
                <meta
                    property="og:description"
                    content="Explore the profound relationship between the Personal Daimōn and the Holy Guardian Angel within the Divine Infinite Being doctrine. Understand their roles as guiding spiritual entities, connecting individuals to the Divine essence, and their influence on personal growth and higher consciousness."
                ></meta>

                <meta property="og:image:width" content="1200"></meta>
                <meta property="og:image:height" content="627"></meta>
                <meta
                    property="og:url"
                    content="https://www.divineinfinitebeing.com/central-doctrine?chapter=41"
                ></meta>

                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
                <meta property="twitter:image:alt" content="Illustration depicting the connection between an individual and their Personal Daimōn and Holy Guardian Angel, symbolizing spiritual guidance and the path to Divine enlightenment within the Divine Infinite Being doctrine."></meta>
                <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=41"></meta>
                <meta name="twitter:title" content="PERSONAL DAIMŌN AND HOLY GUARDIAN ANGEL | School of Our Divine Infinite Being"></meta>
                <meta name="twitter:description" content="Explore the profound relationship between the Personal Daimōn and the Holy Guardian Angel within the Divine Infinite Being doctrine. Understand their roles as guiding spiritual entities, connecting individuals to the Divine essence, and their influence on personal growth and higher consciousness."></meta>
                <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=41" />
            </Head>


            <Common_html BlockData={BlockData} />
        </>
    );
}
